import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const getFields = pageType => {
  if (pageType === 'checkout') {
    return [
      {
        type: 'disclosure',
        label: 'Product',
        fields: [
          { name: 'intervalCountText', type: 'text', label: 'Interval count' },
          { name: 'dayText', type: 'text', label: 'Day' },
          { name: 'weekText', type: 'text', label: 'Week' },
          { name: 'monthText', type: 'text', label: 'Month' },
          { name: 'yearText', type: 'text', label: 'Year' },
          { name: 'trialDaysFreeText', type: 'text', label: 'Trial days free' },
          { name: 'trialThenText', type: 'text', label: 'Trial then' },
          { name: 'setupFeeText', type: 'text', label: 'Setup fee' },
          { name: 'cartSetupFeeText', type: 'text', label: 'Price breakdown setup fee' },
          { name: 'startsOnText', type: 'text', label: 'Starts on' },
          { name: 'renewsOnText', type: 'text', label: 'Renews on' },
          { name: 'todayText', type: 'text', label: 'Today' },
          { name: 'proratedAmountText', type: 'text', label: 'Prorated amount' },
          { name: 'endsAfterText', type: 'text', label: 'Ends after' },
          { name: 'endsAfterPaymentsText', type: 'text', label: 'Ends after payments' },
          { name: 'variantOptionTotalText', type: 'text', label: 'Variant option total' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Checkout form',
        fields: [
          { name: 'soldOutText', type: 'text', label: 'Sold out' },
          { name: 'canceledText', type: 'text', label: 'Canceled' },
          { name: 'canceledButtonText', type: 'text', label: 'Canceled button' },
          { name: 'soldOutButtonText', type: 'text', label: 'Sold out button' },
          { name: 'paymentDetailsText', type: 'text', label: 'Payment details' },
          { name: 'emailSuggestionText', type: 'text', label: 'Did you mean' },
          { name: 'addDiscountCodeText', type: 'text', label: 'Add discount code' },
          { name: 'discountCodeText', type: 'text', label: 'Discount code' },
          {
            name: 'discountCodePlaceholderText',
            type: 'text',
            label: 'Discount code placeholder',
          },
          { name: 'discountCodeApplyText', type: 'text', label: 'Discount code apply' },
          { name: 'payWhatYouWantText', type: 'text', label: 'Pay what you want' },
          {
            name: 'payWhatYouWantPlaceholderText',
            type: 'text',
            label: 'Pay what you want placeholder',
          },
          { name: 'orPayWithCardText', type: 'text', label: 'Or pay with card' },
          { name: 'cardLabelText', type: 'text', label: 'Card label' },
          { name: 'variantIsRequiredText', type: 'text', label: 'Variant is required' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Price breakdown',
        fields: [
          { name: 'cartSubtotalText', type: 'text', label: 'Price breakdown subtotal' },
          { name: 'cartBulkDiscountText', type: 'text', label: 'Price breakdown bulk discount' },
          {
            name: 'cartCouponDiscountText',
            type: 'text',
            label: 'Price breakdown coupon discount',
          },
          { name: 'cartTaxText', type: 'text', label: 'Price breakdown tax' },
          {
            name: 'cartTotalOnStartDateText',
            type: 'text',
            label: 'Price breakdown total on start date',
          },
          {
            name: 'cartTotalAfterTrialText',
            type: 'text',
            label: 'Price breakdown total after trial',
          },
          { name: 'cartDueNowText', type: 'text', label: 'Price breakdown due now' },
          { name: 'cartTotalDueText', type: 'text', label: 'Price breakdown total due' },
          {
            name: 'cartTotalDueProratedAmountText',
            type: 'text',
            label: 'Price breakdown total due (prorated amount)',
          },
        ],
      },
      {
        type: 'disclosure',
        label: 'Buttons',
        fields: [
          { name: 'payButtonText', type: 'text', label: 'Pay button' },
          { name: 'subscribeButtonText', type: 'text', label: 'Subscribe button' },
          { name: 'submitButtonText', type: 'text', label: 'Submit button' },
        ],
      },
      {
        type: 'disclosure',
        label: 'After payment',
        fields: [
          { name: 'upsellNoThanksText', type: 'text', label: 'Upsell no thanks' },
          { name: 'processingPaymentText', type: 'text', label: 'Processing payment' },
          { name: 'viewDownloadsText', type: 'text', label: 'View downloads' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Other',
        fields: [{ name: 'securePaymentsText', type: 'text', label: 'Secure payments' }],
      },
    ];
  } else if (pageType === 'form') {
    return [
      {
        type: 'disclosure',
        label: 'Form',
        fields: [
          { name: 'formDetailsText', type: 'text', label: 'Complete your details' },
          { name: 'emailSuggestionText', type: 'text', label: 'Did you mean' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Buttons',
        fields: [{ name: 'submitButtonText', type: 'text', label: 'Submit button' }],
      },
      {
        type: 'disclosure',
        label: 'After payment',
        fields: [{ name: 'viewDownloadsText', type: 'text', label: 'View downloads' }],
      },
    ];
  } else if (pageType === 'event') {
    return [
      {
        type: 'disclosure',
        label: 'Event',
        fields: [
          { name: 'ticketTypeTotalText', type: 'text', label: 'Ticket type total' },
          { name: 'ticketsRemainingText', type: 'text', label: 'remaining' },
          { name: 'canceledButtonText', type: 'text', label: 'Canceled button' },
          { name: 'soldOutButtonText', type: 'text', label: 'Sold out button' },
          { name: 'soldOutText', type: 'text', label: 'Sold out' },
          { name: 'canceledText', type: 'text', label: 'Canceled' },
          { name: 'unavailableText', type: 'text', label: 'Unavailable' },
          { name: 'onSaleSoonText', type: 'text', label: 'On sale soon' },
          { name: 'notOnSaleText', type: 'text', label: 'Not on sale' },
          { name: 'startDateText', type: 'text', label: 'Starts' },
          { name: 'endDateText', type: 'text', label: 'Ends' },
          { name: 'endedAtDateText', type: 'text', label: 'Ended on' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Form',
        fields: [
          { name: 'formDetailsText', type: 'text', label: 'Complete your details' },
          { name: 'emailSuggestionText', type: 'text', label: 'Did you mean' },
          { name: 'addDiscountCodeText', type: 'text', label: 'Add discount code' },
          { name: 'discountCodeText', type: 'text', label: 'Discount code' },
          {
            name: 'discountCodePlaceholderText',
            type: 'text',
            label: 'Discount code placeholder',
          },
          { name: 'discountCodeApplyText', type: 'text', label: 'Discount code apply' },
          { name: 'orPayWithCardText', type: 'text', label: 'Or pay with card' },
          { name: 'cardLabelText', type: 'text', label: 'Card label' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Price breakdown',
        fields: [
          { name: 'cartSubtotalText', type: 'text', label: 'Price breakdown subtotal' },
          {
            name: 'cartCouponDiscountText',
            type: 'text',
            label: 'Price breakdown coupon discount',
          },
          { name: 'cartTaxText', type: 'text', label: 'Price breakdown tax' },
          { name: 'cartDueNowText', type: 'text', label: 'Price breakdown due now' },
          { name: 'cartTotalDueText', type: 'text', label: 'Price breakdown total due' },
        ],
      },
      {
        type: 'disclosure',
        label: 'Buttons',
        fields: [
          { name: 'getTicketsButtonText', type: 'text', label: 'Get tickets button' },
          { name: 'soldOutButtonText', type: 'text', label: 'Sold out button' },
        ],
      },
      {
        type: 'disclosure',
        label: 'After payment',
        fields: [
          { name: 'upsellNoThanksText', type: 'text', label: 'Upsell no thanks' },
          { name: 'processingPaymentText', type: 'text', label: 'Processing payment' },
          {
            name: 'ticketsPurchasedText',
            type: 'text',
            label: 'Tickets purchased',
          },
        ],
      },
      {
        type: 'disclosure',
        label: 'Other',
        fields: [{ name: 'securePaymentsText', type: 'text', label: 'Secure payments' }],
      },
    ];
  } else {
    return [];
  }
};

const CustomLabelsForm = () => {
  const { page, updatePage } = usePage();

  const fields = getFields(page.type);

  const flattenFields = (fields, pageData) => {
    return fields.reduce((acc, field) => {
      if (field.type === 'disclosure') {
        return { ...acc, ...flattenFields(field.fields, pageData) };
      }

      return { ...acc, [field.name]: pageData?.[field.name] };
    }, {});
  };

  const initialValues = flattenFields(fields, page);

  return (
    <Form
      initialValues={initialValues}
      fields={fields}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.resetForm({
            values: flattenFields(fields, data),
          });
        }

        return {
          data,
          error,
        };
      }}
      submitButton={{
        label: 'Save',
      }}
      showState={true}
    />
  );
};

export default CustomLabelsForm;
